<template>
  <div class="productFileterMb d-md-none d-block" :class="{'athena-filter':theme==='athena'}">
    <div class="filter-mb-onoff">
      <button @click="drawer = true" :class="filter_button ?'filter_button': 'main_button'">
        {{ $t("filter.refine_by") }}
      </button>
    </div>
    <div class="mb-drawer">
      <el-drawer :visible.sync="drawer" :withHeader="false" :modal-append-to-body="false">
        <header class="mb-header">
          <span class="athena_hidden iconfont icon-cancel-1-copy" @click="drawer = false" style="font-weight: 600"></span>
          <h5 style="font-size: 16px; font-weight: 600"  class="title_font">
            {{ $t("filter.refine_by") }}
          </h5>
          <span class="athena_hidden page_text_font" @click="clearFilter"> {{$t(`filter${theme && theme=='athena'?'.athena':''}.clear_all`)}}</span>
          <span class="athena_close iconfont icon-cancel-1-copy" @click="drawer = false" style="font-weight: 600"></span>
        </header>
        <div class="drawer-main">
          <template v-for="(item, index) in product_filter.items">
            <div
              class="filter-wrap"
              v-if="item.status && item.status === true"
              :key="item.type + index"
            >
              <v-collapse-card
                :title="item.title"
                :collapse_key="item.title + item.type + index"
                :default_show="!item.list_collapse"
              >
                <v-filterIndex
                  :filterItem="item"
                  :payload="payload"
                ></v-filterIndex>
              </v-collapse-card>
            </div>
          </template>
        </div>
        <footer class="athena_hidden res-btn main_button" @click="mb_filter">
          {{ $t("filter.show_results") }}
        </footer>
        <div class="athena_footer">
        <footer class="res-btn" >
          <span @click="mb_filter">
              {{ $t("filter.show_results") }}
          </span>
           <span @click="clearFilter">
              {{ $t("filter.clear_all") }}
          </span>
        </footer>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
<script>
import vCollapseCard from "../../common/collapseCard";
import vFilterIndex from "./filterIndex";
export default {
  props: ["product_filter", "payload", "theme","filter_button"],
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    clearFilter() {
      let payload = {
        right_now: true,
      };
      for (const key in this.payload) {
        payload[key] = [];
      }
      this.bus.$emit("changeFilter", payload);
    },
    mb_filter() {
      this.drawer = false;
      this.bus.$emit("changeFilter", { right_now: true });
    },
  },
  watch: {
     drawer(newV) {
       this.bus.$emit("change_filter_zindex", newV);
     }
  },
  components: {
    vCollapseCard,
    vFilterIndex,
  },
};
</script>
<style scoped lang='scss'>
button {
  border: none;
  background-color: transparent;
}
a {
  text-decoration: none;
  color: black;
}
.productFileterMb {
  .filter-mb-onoff {
    button {
      display: inline-block;
      width: 100%;
      color: white;
      font-size: 16px;
      padding: 12px 15px;
    }
  }
  .mb-drawer ::v-deep .el-drawer__wrapper {
    .el-drawer {
      width: 300px !important;
      max-width: 100%;
      .el-drawer__header {
        border-bottom: 1px solid #dfdfdf;
        padding: 15px;
      }
      .el-drawer__body {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        overflow: hidden;
        .mb-header {
          display: flex;
          padding: 12px 15px;
          justify-content: space-between;
          align-items: center;
          border: 1px solid #dfdfdf;
          font-size: 14px;
          margin-bottom: 0;
          span {
            cursor: pointer;
          }
        }
        .drawer-main {
          overflow-y: auto;
          flex: 1;
          .filter-wrap {
            .collapseCard {
              padding: 0 24px;
              .collapseCardTitle {
                padding-top: 20px;
                padding-bottom: 20px;
                margin-bottom: 0;
                h5 {
                  font-size: 14px;
                }
              }
              .nextCrrows {
                width: 7px;
                height: 7px;
              }
              .arrows-top {
                transform: translate(-25%, -6%) rotate(-135deg);
              }
            }
          }
        }
        .res-btn {
          width: 100%;
          padding: 15px;
          text-align: center;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
  }
}
.athena_close,.athena_footer {
  display: none;
}
.athena-filter {
  .athena_hidden {
    display: none !important;
  }
  .athena_close {
    display: block;
    margin-right: 10px;
    border: 1px solid #676c7b;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    font-size: 13px;
    text-align: center;
    color: #676c7b;
  }
  .athena_footer {
    display: flex;
    .res-btn {
    display: flex;
    padding: 0 15px 2px 15px !important;
    span {
    border: 1px solid #90949f;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    width: 50%;
    }
    span:first-child {
      border-right: none;
    }
    }
  }
 .filter-check-list {
  border-bottom: 1px solid #EAEAEA;
  padding-bottom: 23px;
  }
 .filter-wrap:not(:last-child) {
   border-bottom: 1px solid #EAEAEA;;
 }
 & ::v-deep {
   .mb-drawer .el-drawer__wrapper .el-drawer {
    width:350px !important;
   }
   .filter-color .color-slider{
     .el-checkbox-group label {
       width: 50% !important;
       flex-wrap: nowrap;
       margin-bottom: 14px !important;
     }
     .el-checkbox-group .half-circle {
       left:15px !important
     }
     .el-checkbox__input {
       width: 30px !important;
     }
     .el-checkbox__label {
       width: 80% !important;
       line-height: 30px !important;
       > span:first-child {
         white-space: nowrap !important;
         text-overflow: ellipsis;
         overflow: hidden;
         display: block;
         padding: 0 5px 0 11px;
         text-align: left;
       }
     }
     .el-checkbox__input::after {
       left: 42% !important;
     }
   }
   .el-checkbox__inner {
       border-radius: 50% !important;
   }
 }
}
</style>
